import { segmenter } from './segmenter';

export const wordCount = (text?: string): number => {
	if (!text) return 0;
	// We use Intl here since it is locale-aware and accurately handles word counts across all languages. The regex will undercount non-English languages.
	if (segmenter) {
		return [...segmenter.segment(text)].filter((s) => s.isWordLike).length;
	}
	return text.match(/\S+/g)?.length ?? 0;
};
